import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Link } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

export const TermsOfUse = () => {
  return (
    <Box gap="s12">
      <Text size="500" color="grey1000" weight="medium">
        {i18n.t('marketplace.terms_of_use.title')}
      </Text>

      <Box paddingLeft="s4">
        <F0Link href="https://factorialhr.com/integrations-clients" target="_blank">
          <Text size="300" color="grey800" weight="medium" underlined>
            {i18n.t('marketplace.terms_of_use.link')}
          </Text>
        </F0Link>
      </Box>
    </Box>
  )
}
